var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "561px",
    height: "574px",
    viewBox: "0 0 561 574",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EY Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.974 560.394 0.974 560.394 574 0.06 574"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EY_Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#FFFFFE",
    points: "89.916 462.031 192.417 462.031 192.417 402.511 89.916 402.511 89.916 355.734 203.304 355.734 165.685 290.537 4.903 290.537 4.903 574 231.667 574 231.667 508.803 89.916 508.803 89.916 462.031"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-2",
    fill: "#FFFFFE",
    points: "382.589 290.537 334.439 383.042 286.405 290.537 192.411 290.537 291.452 462.031 291.452 574 376.206 574 376.206 462.031 475.378 290.537 382.589 290.537"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#FBD020",
    points: "560.394 0.974 0 205.505 560.394 106.511 560.394 0.974"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyLogo);
export default __webpack_public_path__ + "static/media/ey-logo.3ae5ba5a68d2a127edb85d38ec8052ac.svg";
export { ForwardRef as ReactComponent };